import React from "react";
import "../../../pages/Surveys/style.css"
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../../Constants";

 
import { FaTimes, FaEdit, FaFileExport,FaArrowRight, FaExclamationCircle, FaTimesCircle, FaCheckCircle } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Component } from "ag-grid-community";
import ability from '../../config/defineAbility';
import { PERMS } from '../../config/perms'


const MyToilRequests = (props) => {
  const history = useHistory();
  const [is_loading, setIsLoading] = useState(false);

  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
const [status, setstatus] = useState(10001)
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  const onBtnExport = useCallback((params) => {
    var params = {
      columnKeys: [
        "staff_id",
        "staff_name",
        "email",
        "role_name",
        "office_name",
        "contract_start_date",
        "contract_end_date",
        "contract_expires_after",
      ],
      fileName: `EmployeeList-${window.h.get_half_formattedDate()}.csv`,
    };
    gridRef.current.api.exportDataAsCsv(params);
  }, []);
  useEffect(() => {
    fetch_data(status);
    return () => {};
  }, []);

  const fetch_data = (_status) => {
    setIsLoading(true);
    genericGet(ENDPOINTS.MY_TOIL_REQUESTS)
    .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
                let responseData = res.data.data;
             
                setRowData(responseData);
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
        setIsLoading(false);
        console.log(err);
    });
   
  };

  return (
    <div>
          <h1> My  Toil Requests</h1>

      
      <div className="ag-theme-alpine">
     





        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef}
          //   overlayLoadingTemplate={
          //     '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          //   }

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
            params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => history.push(`/hrm/toil/details/${e.data.id}`)}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },
            {
              headerName: "Requested at  ",
              field: "created_at",
              sortable: true,
              filter: true,
            
            },
            {
              headerName: "Staff Name ",
              field: "",
              sortable: true,
              filter: true,
              cellRendererFramework: (e) => {
                return e?.data?.staff?.staff_name;
                              }
            },
            {
              headerName: "Subject",
            
              sortable: true,
              filter: true,
              cellRendererFramework: (e) => {
return e?.data?.subject??"";
              }
            },
            
            {
              headerName: "Total Days ",
              field: "total_toil_days",
              sortable: true,
              filter: true,
            
            },
            {
              headerName: "Return Date  ",
              field: "return_to_office",
              sortable: true,
              filter: true,
            
            },
          
            {
              headerName: "Approval",
        
              sortable: true,
              filter: true,
              
              cellRendererFramework: (e) => {
               
                if(e?.data?.request_approver_1_status==10000){
                  return "Pending";
                }
                if(e?.data?.request_approver_1_status==10002){
                  return "Rejected";
                }
                
                if(e?.data?.request_approver_2_status==10000){
                  return "Pending";
                }
                if(e?.data?.request_approver_2_status==10002){
                  return "Rejected";
                } else
                {
                  return "Approved";
                }



                              }
            
            },
            
             
            {
              headerName: "Claim_date  ",
              field: "claim_date",
              sortable: true,
              filter: true,
            
            },
            


            {
              headerName: "Actions",
              field: "",
              sortable: true,
              filter: true,
             
              cellRendererFramework: (e) => {
                return (
                 
    

                  <button
                  className="badge btn-primary"
                    onClick={() => {
                    
try{
                      history.push(`/hrm/toil/details/${e.data.id}`);

                    }catch(e){
                      alert(e)
                    }
                    }}
                  >
                    View   &nbsp;  <FaArrowRight style={{ color: "white", cursor: "pointer" }} />
                  </button>
                  
                  
                  
           

                );
              },
            },




          ]}
        ></AgGridReact>
     
     
      </div>{" "}

    
    </div>
  );
};

export default MyToilRequests;
